/**
 * 파일 확장자에 따른 아이콘(썸네일) URL 매핑 유틸
 * WeHago 공용 아이콘 패밀리(icon_file/{size}x{size}/ico_[fn_]{name}_{size}.png)를 사용한다.
 *
 * 확장자를 그대로 URL에 넣으면(pptx, xlsx, docx, hwpx, jpeg, show 등) 존재하지 않는
 * 에셋이 되어 404 → etc 아이콘으로 폴백되므로, 확장자를 실제 에셋 이름으로 정규화한다.
 */

const STATIC_PATH = 'https://static.wehago.com';

/** 확장자 → 아이콘 에셋 이름 정규화 */
function resolveIconName(ext: string, size: number): string {
  switch (ext) {
    case 'pdf': case 'pptx': case 'ppt': case 'xlsx': case 'xls':
    case 'docx': case 'doc': case 'hwp': case 'hwpx': case 'txt':
    case 'jpg': case 'png': case 'gif': case 'tif': case 'tiff':
    case 'one': case 'onex':
      return ext.slice(0, 3);
    case 'cell': case 'word':
      return ext;
    case 'jpeg':
      return size === 40 ? 'jpg' : 'jpeg';
    case 'show':
      return 'hanshow';
    default:
      return 'etc';
  }
}

/**
 * 파일 타입/확장자에 맞는 아이콘 URL을 반환한다.
 * @param type 확장자(예: 'pptx') 또는 파일 타입
 * @param size 아이콘 사이즈(기본 120)
 * @param staticPath 정적 리소스 베이스 경로
 */
export function getFileIconUrl(type: string, size: number = 120, staticPath: string = STATIC_PATH): string {
  const ext = (type || '').toLowerCase();
  const prefix = size === 120 ? 'fn_' : '';
  const name = resolveIconName(ext, size);
  return `${staticPath}/imgs/common/icon_file/${size}x${size}/ico_${prefix}${name}_${size}.png`;
}

/** 파일명에서 확장자 추출(소문자, 점 제외). 없으면 'etc' */
export function getFileExt(fileName: string): string {
  const match = fileName.match(/\.([^.]+)$/);
  return match ? match[1].toLowerCase() : 'etc';
}
